/* angular:styles/component:css;6fb0ca5aabef287fa25722d1fe13baa0c5fc78e9a8faab84b22e5f980b5d080e;/opt/atlassian/pipelines/agent/build/src/app/tab-signals/tab-signals.page.ts */
ion-label.wrapped {
  text-overflow: unset !important;
  white-space: normal !important;
  overflow: auto !important;
}
ion-item [slot=end] {
  margin-left: 8px;
  margin-right: 8px;
}
ion-button {
  margin-inline-start: 6px;
  margin-inline-end: 6px;
}
ion-item.signal {
  cursor: pointer;
}
/*# sourceMappingURL=tab-signals.page.css.map */
